var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBestModelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "show-sidebar-vert-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160560",
    "data-name": "Group 160560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160559",
    "data-name": "Group 160559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15401",
    "data-name": "Path 15401",
    d: "M20,24H4a4.012,4.012,0,0,1-4-4V4A4.012,4.012,0,0,1,4,0H20a4.012,4.012,0,0,1,4,4V20A4.012,4.012,0,0,1,20,24ZM4,2A2.006,2.006,0,0,0,2,4V20a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V4a2.006,2.006,0,0,0-2-2Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_160562",
    "data-name": "Group 160562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160561",
    "data-name": "Group 160561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15402",
    "data-name": "Path 15402",
    d: "M23,9H1A.945.945,0,0,1,0,8,.945.945,0,0,1,1,7H23a.945.945,0,0,1,1,1A.945.945,0,0,1,23,9Z",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_160567",
    "data-name": "Group 160567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160564",
    "data-name": "Group 160564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160563",
    "data-name": "Group 160563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15403",
    "data-name": "Path 15403",
    d: "M12,18a.908.908,0,0,1-.7-.3.967.967,0,0,1,0-1.4l3-3a.99.99,0,0,1,1.4,1.4l-3,3A.908.908,0,0,1,12,18Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160566",
    "data-name": "Group 160566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160565",
    "data-name": "Group 160565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15404",
    "data-name": "Path 15404",
    d: "M12,18a.908.908,0,0,1-.7-.3l-3-3a.99.99,0,0,1,1.4-1.4l3,3a.967.967,0,0,1,0,1.4A.908.908,0,0,1,12,18Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestModelIcon);
export default __webpack_public_path__ + "static/media/best_model_icon.f48c2b69ad0469fe89a834a984c9e491.svg";
export { ForwardRef as ReactComponent };